import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { setLoadingState } from "redux/actions";

import { AppDispatch } from "redux/store";

import { criarArquivo } from "helpers";

import "assets/scss/transfer.scss";

import { resolveImageDimensions, resizeFile } from "./imageUploadHelpers";

interface CustomEditorComponent {
  onChange: (...args: any) => void;
  setModalVisibility: React.Dispatch<React.SetStateAction<boolean>>;
  setType: React.Dispatch<React.SetStateAction<"success" | "danger">>;
  setApiError: React.Dispatch<React.SetStateAction<string>>;
}

const CustomImageModal: React.FC<CustomEditorComponent> = ({ onChange }) => {
  const ref = useRef<HTMLInputElement | null>(null);
  const dispatch = useDispatch<AppDispatch>();

  const handleClick = () => {
    if (ref.current) {
      ref.current.click();
    }
  };

  const onChangeFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      dispatch(setLoadingState(true));
      const [originalWidth, originalHeight] = await resolveImageDimensions(
        e.target.files[0]
      );

      try {
        const {
          data: {
            arquivos: [newProfilePic],
          },
        } = await criarArquivo(e.target.files, "1", "", true);

        const [width, height] = resizeFile(originalWidth, originalHeight);

        onChange(newProfilePic.path, height, width);
      } catch (error) {
        console.log({ error });
      }
      dispatch(setLoadingState(false));
    }
  };

  return (
    <div className="dropdown">
      <button
        onClick={handleClick}
        id="click-dropdown"
        className="dropdown-toggle btn btn-light"
        type="button"
      >
        <i className="mdi mdi-image-outline"></i>
      </button>
      <input
        type="file"
        hidden
        id="input-file"
        ref={ref}
        onChange={onChangeFile}
      />
    </div>
  );
};

interface CustomImageModalLocalProps {
  onChange: (...args: any) => void;
  onFileSelected?: (blobUrl: string, file: File) => void;
}

/**
 * Variante que insere a imagem usando uma URL local (blob:), sem upload.
 * Usada apenas na tela de Comunicados, onde o upload real só ocorre no submit.
 */
export const CustomImageModalLocal: React.FC<CustomImageModalLocalProps> = ({
  onChange,
  onFileSelected,
}) => {
  const ref = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    if (ref.current) {
      ref.current.click();
    }
  };

  const onChangeFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const [originalWidth, originalHeight] = await resolveImageDimensions(file);

    const [width, height] = resizeFile(originalWidth, originalHeight);
    const blobUrl = URL.createObjectURL(file);
    onFileSelected?.(blobUrl, file);

    onChange(blobUrl, height, width);

    e.target.value = "";
  };

  return (
    <div className="dropdown">
      <button
        onClick={handleClick}
        id="click-dropdown"
        className="dropdown-toggle btn btn-light"
        type="button"
      >
        <i className="mdi mdi-image-outline"></i>
      </button>
      <input
        type="file"
        hidden
        id="input-file"
        ref={ref}
        onChange={onChangeFile}
      />
    </div>
  );
};

export default CustomImageModal;
